import { Live360Detector } from './Live360Detector';
import { Live360DetectorListener } from './Live360DetectorListener';

export class DefaultLive360Detector implements Live360Detector {
  private isAvailable = false;

  constructor(
    private _startEpochTime: number,
    private _endEpochTime: number,
    private listener: Live360DetectorListener,
  ) {
    // no-op
  }

  get startEpochTime(): number {
    return this._startEpochTime;
  }

  get endEpochTime(): number {
    return this._endEpochTime;
  }

  setStartEpochTime(startTime: number): void {
    this._startEpochTime = startTime;
  }

  setEndEpochTime(endTime: number): void {
    this._endEpochTime = endTime;
  }

  setCurrentPlayhead(currentEpochTime: number): void {
    if (this.didStateChange(currentEpochTime)) {
      this.listener.onStateChange(this.isAvailable);
    }
  }

  private didStateChange(currentEpochTime: number): boolean {
    if (this.inRange(currentEpochTime) && !this.isAvailable) {
      this.isAvailable = true;
      return true;
    } else if (!this.inRange(currentEpochTime) && this.isAvailable) {
      this.isAvailable = false;
      return true;
    }

    return false;
  }

  private inRange(currentEpoch: number): boolean {
    return currentEpoch >= this._startEpochTime && currentEpoch <= this._endEpochTime;
  }
}
